export const SCORE_EXPLAINER_TITLE = "Your score is ready";

export const SCORE_EXPLAINER_BODY =
  "Your score reflects how consistently you show up. " +
  "It's forgiving \u2014 missing a day barely moves it. " +
  "It'll keep climbing as long as you keep going.";

export const SCORE_EXPLAINER_CTA = "Got it";

export const SCORE_EXPLAINER_DETAIL =
  "Skipping a day counts less than missing one. " +
  "Your score is always catching up to your recent behavior.";
